import React from 'react'
import Loader from 'semantic-ui-react/dist/es/elements/Loader/Loader'

const VmoLoader = (props) => {
  return <Loader {...props}/>
}

export default VmoLoader
